import { Link } from "react-router";

type SidebarMotionLinkProps = React.ComponentProps<typeof Link> & { disableHover?: boolean };

export function SidebarMotionLink({
  disableHover: _disableHover,
  ...props
}: SidebarMotionLinkProps) {
  return <Link {...props} />;
}

SidebarMotionLink.displayName = "SidebarMotionLink";
